import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, AppBar, Tabs, Tab } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  loadAccountingCapitalBalanceAction,
  loadAccountingInterestBalanceAction
} from 'src/store/actions/contractActions';
import AccountingCapitalBalance from './AccountingCapitalBalance/AccountingCapitalBalance';
import AccountingInterestBalance from './AccountingInterestBalance/AccountingInterestBalance';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`accounting-balance-tabpanel-${index}`}
      aria-labelledby={`accounting-balance-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

const AccountingBalanceTabs = ({
  contract,
  tabIndex,
  setTabIndex,
  actions
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const contractId = contract?.id;

  useEffect(() => {
    if (tabIndex === 0) {
      dispatch(loadAccountingCapitalBalanceAction(contractId));
    } else if (tabIndex === 1) {
      dispatch(loadAccountingInterestBalanceAction(contractId));
    }
  }, [dispatch, contractId, tabIndex]);

  const handleTabChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
    },
    [setTabIndex]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleTabChange}
        >
          <Tab
            label={t(
              'CONTRACT_VIEW.CONTRACT_DETAIL.ACCOUNTING_BALANCE.CAPITAL'
            )}
          />
          <Tab
            label={t(
              'CONTRACT_VIEW.CONTRACT_DETAIL.ACCOUNTING_BALANCE.INTEREST'
            )}
          />
        </Tabs>
        <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
          {actions}
        </Box>
      </AppBar>

      <TabPanel value={tabIndex} index={0}>
        <AccountingCapitalBalance />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <AccountingInterestBalance />
      </TabPanel>
    </Box>
  );
};

AccountingBalanceTabs.propTypes = {
  contract: PropTypes.object,
  tabIndex: PropTypes.number.isRequired,
  setTabIndex: PropTypes.func.isRequired,
  actions: PropTypes.node.isRequired
};

export default AccountingBalanceTabs;
